import { render, staticRenderFns } from "./locationContent.vue?vue&type=template&id=8b161c96"
import script from "./locationContent.vue?vue&type=script&lang=js"
export * from "./locationContent.vue?vue&type=script&lang=js"
import style0 from "./locationContent.vue?vue&type=style&index=0&id=8b161c96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports